<template>
  <div id="page-article-list-edit">
    <vs-alert
      color="danger"
      title="ArticleList Not Found"
      :active.sync="articleList_not_found"
    >
      <span>
        ArticleList record with id
        <strong>{{ $route.params.articleListId }}</strong> not found.
      </span>
      <span>
        <span>Check</span>
        <router-link
          :to="{ name: 'article-list-list' }"
          class="text-inherit underline"
          >All ArticleLists</router-link
        >
      </span>
    </vs-alert>

    <vx-card v-if="articleList_data">
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <vs-input
            class="w-full mt-4"
            :label="$t('ArticleList.Name')"
            v-model="data_local.name"
            v-validate="'required'"
            name="name"
          />
          <span class="text-danger text-sm" v-show="errors.has('name')">{{
            errors.first("name")
          }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full">
          <vs-input
            class="w-full mt-4"
            :label="$t('ArticleList.FeedUrl')"
            v-model="data_local.feedUrl"
            name="feedUrl"
          />
          <span class="text-danger text-sm" v-show="errors.has('feedUrl')">{{
            errors.first("feedUrl")
          }}</span>
        </div>
      </div>
    </vx-card>
    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            class="ml-auto mt-2"
            @click="saveChanges"
            :disabled="!validateForm"
            >{{ this.$t("Save") }}</vs-button
          >
          <vs-button
            class="ml-4 mt-2"
            type="border"
            color="warning"
            @click="cancel"
            >{{ $t("Cancel") }}</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moduleArticleListManagement from '@/store/article-list-management/moduleArticleListManagement.js'
import { notifyMixin } from '@/mixins/notifyMixin'
export default {
  mixins: [notifyMixin],
  data () {
    return {
      articleList_data: null,
      articleList_not_found: false,
      data_local: null
    }
  },
  methods: {
    fetchData (articleListId) {
      this.$store.dispatch('articleListManagement/fetchArticleList', articleListId)
        .then(res => {
          this.articleList_data = res.data.articleList
          this.data_local = JSON.parse(JSON.stringify(this.articleList_data))
          this.data_local.idOrganisation = this.activeOrganisation.id
          if (this.articleList_data === null) {
            this.articleList_not_found = true
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.articleList_not_found = true
            return
          }
          console.error(err)
        })
    },
    saveChanges () {
      if (!this.validateForm) return
      this.$vs.loading()
      this.$store.dispatch('articleListManagement/saveArticleList', this.data_local)
        .then(() => {
          this.$router.push("/articleList/list")
          this.$vs.loading.close()
          this.notifySuccess(this.data_local.id ? this.$t('ArticleList.Updated') : this.$t('ArticleList.Created'))
        })
        .catch(error => {
          this.notifyError(error)
          this.$vs.loading.close()
        })
    },
    cancel () {
      this.$router.push("/articlelist/list")
    }
  },
  watch: {
    activeOrganisation: function (val) {
      console.log(`activeOrganisation changed to ${val.id}`)
      this.refreshGrid()
    },

  },
  computed: {
    ...mapGetters(["activeOrganisation"]),
    validateForm () {
      return !this.errors.any()
    }
  },
  created () {
    if (!moduleArticleListManagement.isRegistered) {
      this.$store.registerModule('articleListManagement', moduleArticleListManagement)
      moduleArticleListManagement.isRegistered = true
    }
    this.fetchData(this.$route.params.articleListId)
  }
}

</script>
